/* ==========================================================================
   Solzaleben, vloeren-PDP: interactie onder de vouw.
   - Ankerbalk: links naar blokken die niet bestaan of verborgen zijn
     (geen reviews, geen Bid & Buy) verdwijnen; het blok in beeld krijgt
     aria-current. De Bid & Buy-band wordt pas later zichtbaar, dus de balk
     kijkt mee met dat hidden-attribuut.
   - FAQ: accordeons met aria-expanded.
   - Ähnliche Böden: sectie ophalen via Shopify's recommendations-route.
   Kan door meerdere secties geladen worden; draait maar één keer.
   ========================================================================== */
(function () {
  'use strict';

  if (window.SolzaPdpInhalt) return;
  window.SolzaPdpInhalt = true;

  function zichtbaar(el) {
    return el && !el.closest('[hidden]');
  }

  /* ---------------------------------------------------------------- Anker */
  function initAnker() {
    var nav = document.querySelector('[data-solza-anker]');
    if (!nav) return;
    var links = Array.prototype.slice.call(nav.querySelectorAll('a[href^="#"]'));
    var actief = null;

    function doel(link) {
      return document.getElementById(link.getAttribute('href').slice(1));
    }

    function bijwerken() {
      var over = 0;
      links.forEach(function (link) {
        var ok = zichtbaar(doel(link));
        link.hidden = !ok;
        if (ok) over += 1;
      });
      nav.hidden = over === 0;
    }

    function markeer(link) {
      if (actief === link) return;
      if (actief) actief.removeAttribute('aria-current');
      actief = link;
      if (link) link.setAttribute('aria-current', 'true');
    }

    bijwerken();

    // De Bid & Buy-band (en eventueel andere blokken) kan later verschijnen.
    links.forEach(function (link) {
      var d = doel(link);
      if (!d) return;
      var wrap = d.closest('[data-solza-bid-trigger-wrap]') || d;
      new MutationObserver(bijwerken).observe(wrap, { attributes: true, attributeFilter: ['hidden'] });
    });

    if ('IntersectionObserver' in window) {
      var inBeeld = new Map();
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (e) {
            inBeeld.set(e.target, e.isIntersecting);
          });
          var gekozen = null;
          links.forEach(function (link) {
            var d = doel(link);
            if (!gekozen && !link.hidden && d && inBeeld.get(d)) gekozen = link;
          });
          markeer(gekozen);
        },
        { rootMargin: '-30% 0px -60% 0px' }
      );
      links.forEach(function (link) {
        var d = doel(link);
        if (d) io.observe(d);
      });
    }
  }

  /* ------------------------------------------------------------------ FAQ */
  function initFaq() {
    document.addEventListener('click', function (event) {
      var knop = event.target.closest && event.target.closest('[data-solza-faq-toggle]');
      if (!knop) return;
      var paneel = document.getElementById(knop.getAttribute('aria-controls'));
      if (!paneel) return;
      var open = knop.getAttribute('aria-expanded') === 'true';
      knop.setAttribute('aria-expanded', open ? 'false' : 'true');
      paneel.hidden = open;
    });

    // "Unsicher? Frag uns" opent de vraag-drawer van de FAQ-sectie; staat die
    // niet op de pagina, dan verbergen we de link.
    if (!document.getElementById('SolzaFrageDrawer')) {
      document.querySelectorAll('[data-solza-frag-wrap]').forEach(function (el) {
        el.hidden = true;
      });
    }
  }

  /* ----------------------------------------------------------- Uitklappen */
  // Beschrijving: na ca. 6 regels inklappen met fade, alleen als hij langer is.
  // Technische Daten: op mobiel eerst 6 rijen (CSS); de knop toont de rest.
  // Alles staat in de HTML; zonder JS blijft alles open.
  function initUitklap() {
    var REGELS = 6;

    document.querySelectorAll('[data-solza-inklap]').forEach(function (blok) {
      var knop = document.querySelector('[data-solza-uitklap][aria-controls="' + blok.id + '"]');
      if (!knop) return;
      var regel = parseFloat(getComputedStyle(blok).lineHeight) || 26;
      // Eén regel speling: geen knop voor een tekst die maar net te lang is.
      if (blok.scrollHeight <= regel * (REGELS + 1)) return;
      blok.style.setProperty('--solza-inklap-hoogte', Math.round(regel * REGELS) + 'px');
      blok.classList.add('is-ingeklapt');
      knop.hidden = false;
    });

    document.querySelectorAll('table[data-solza-kort]').forEach(function (tabel) {
      var knop = document.querySelector('[data-solza-uitklap][aria-controls="' + tabel.id + '"]');
      if (!knop) return;
      tabel.classList.add('is-kort');
      knop.hidden = false;
    });

    document.addEventListener('click', function (event) {
      var knop = event.target.closest && event.target.closest('[data-solza-uitklap]');
      if (!knop) return;
      var doel = document.getElementById(knop.getAttribute('aria-controls'));
      if (!doel) return;
      var open = knop.getAttribute('aria-expanded') === 'true';
      var klasse = doel.tagName === 'TABLE' ? 'is-kort' : 'is-ingeklapt';
      doel.classList.toggle(klasse, open);
      knop.setAttribute('aria-expanded', open ? 'false' : 'true');
      knop.textContent = open ? knop.dataset.labelDicht : knop.dataset.labelOpen;
      // Weer dichtgeklapt en het begin uit beeld: terug naar het blok.
      if (open && doel.getBoundingClientRect().top < 0) doel.scrollIntoView({ block: 'start' });
    });
  }

  /* ------------------------------------------------------ Aanbevelingen */
  function initAanbevelingen() {
    document.querySelectorAll('[data-solza-aanbevelingen]').forEach(function (houder) {
      var url = houder.getAttribute('data-url');
      if (!url || houder.children.length) return;
      fetch(url)
        .then(function (r) {
          return r.ok ? r.text() : '';
        })
        .then(function (html) {
          if (!html) return;
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var nieuw = doc.querySelector('[data-solza-aanbevelingen]');
          if (nieuw && nieuw.children.length) houder.innerHTML = nieuw.innerHTML;
        })
        .catch(function () {
          /* geen aanbevelingen: sectie blijft leeg */
        });
    });
  }

  function init() {
    try {
      initAnker();
      initFaq();
      initUitklap();
      initAanbevelingen();
    } catch (_fout) {
      /* pagina blijft bruikbaar */
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
